import { injectGlobal } from '@emotion/css';
import { pxToRem } from '../utils';

injectGlobal({
  p: {
    fontFamily: 'var(--font-body)',
    fontSize: pxToRem(16),
    fontWeight: 'var(--font-weight-light)', // InterRegular is too thick for default p text size
    lineHeight: pxToRem(24),
    margin: 0,
    maxWidth: 'var(--max-content-width)',
    paddingBottom: pxToRem(48),
  },
  'p + p': {
    marginTop: pxToRem(-16),
  },
  'p > p:last-child': {
    paddingBottom: 0,
  },
  strong: {
    fontWeight: 'var(--font-weight-bold)',
  },
  small: {
    fontSize: 'smaller',
    lineHeight: 'inherit',
  },

  /* Hiding class, making content visible only to screen readers but not visually */
  '.sr-only': {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    borderWidth: 0,
  },
});
